import React from 'react';
import { Button } from 'reactstrap';
import { useNavigationActions } from '../../../../context';
import { calculateBillingDates } from '../../../../utils';

/**
 * Component that displays the final cancellation success confirmation
 * Shows after successful cancellation with community access information
 */
const CancellationConfirmation = () => {
  // Get navigation actions from context
  const { returnToWLC } = useNavigationActions();
  // Calculate end of current billing period using utility
  const { formattedNextBillingDate } = calculateBillingDates();

  return (
    <div className="cancellation-success-content">
      <div className="mb-4">
        <h5 className="mb-4">Your membership has been canceled.</h5>

        <p className="mb-3">
          We're sorry to see you go, but we're grateful you gave WHOLE Life Club a try, and that you're part of our FRN
          community.
        </p>

        <p className="mb-3">
          You'll continue to have access to your WHOLE Life Club benefits until{' '}
          <strong>{formattedNextBillingDate}</strong>.
        </p>

        <p className="mb-4">
          If you decide to return, you can restart your membership anytime. Your account, recipes, and progress will all
          be waiting for you.
        </p>

        <div className="mb-4 text-center">
          <Button color="primary" onClick={returnToWLC} size="lg">
            Visit WHOLE Life Club Community Now
          </Button>
        </div>

        <div className="cancellation-details text-muted small">
          <p>
            Your membership has been canceled effective {formattedNextBillingDate}. You'll retain access through the end
            of your current billing period. No further charges will occur.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CancellationConfirmation;
